import React from 'react';

import classnames from 'classnames';

import studentWorkStyles from 'pages/Teachers/Insights/components/GradeOverview/components/StudentWorkList/styles.module.scss';
import pageStyles from 'pages/Teachers/Insights/components/GradeOverview/styles.module.scss';
import { StudentCardSkeleton } from 'pages/Teachers/shared/StudentWorkSkeleton';
import { colors } from 'theme/palette';

import MultiSelectFilter from 'components/MultiSelectFilter';
import SelectFilter from 'components/SelectFilter';
import Typography from 'components/Typography';

import filterStyles from '../Filters/styles.module.scss';

const FiltersSkeleton = () => (
  <div className={filterStyles.filterWrapper}>
    <div className={filterStyles.filterBox}>
      <Typography variant="S-TEXT-1" color={colors.grey4}>
        Filter Pages
      </Typography>
      <MultiSelectFilter
        disabled
        className={filterStyles.filterInput}
        options={[]}
        placeholder="All"
      />
    </div>
    <div className={filterStyles.filterBox}>
      <Typography variant="S-TEXT-1" color={colors.grey4}>
        Filter Students
      </Typography>
      <MultiSelectFilter
        disabled
        className={filterStyles.filterInput}
        options={[]}
        placeholder="All"
      />
    </div>
    <div className={filterStyles.filterBox}>
      <Typography variant="S-TEXT-1" color={colors.grey4}>
        Sort by
      </Typography>
      <SelectFilter
        disabled
        placeholder="Most Recent"
        className={filterStyles.filterInput}
        options={[]}
      />
    </div>
    <div className={filterStyles.filterBox}>
      <Typography variant="S-TEXT-1" color={colors.grey4}>
        Show
      </Typography>
      <SelectFilter
        disabled
        placeholder="All Submitted"
        className={filterStyles.filterInput}
        options={[]}
      />
    </div>
  </div>
);

const StudentWorkListSkeleton = ({ lgScreen }) => (
  <div
    className={classnames({
      [studentWorkStyles.wrapper]: lgScreen,
      [studentWorkStyles.smallwrapper]: !lgScreen
    })}
  >
    <div className={studentWorkStyles.studentCardsContainer}>
      <StudentCardSkeleton />
      <StudentCardSkeleton />
      {lgScreen && <StudentCardSkeleton />}
    </div>
  </div>
);

const PageSkeleton = ({ lgScreen }) => (
  <div>
    <div className={pageStyles.headerContainer}>
      <div className={pageStyles.header}>
        <FiltersSkeleton />
      </div>
    </div>

    <StudentWorkListSkeleton lgScreen={lgScreen} />
  </div>
);

export default PageSkeleton;
